import type { WorkspaceBilling } from '../billing/types/billing';

/** Channels can be connected once a trial or paid plan is active. */
export const channelsAreOpen = (workspace: WorkspaceBilling | null): boolean => {
  if (!workspace) {
    return false;
  }

  if (workspace.canEditFeatures || !workspace.entitlementsKnown) {
    return true;
  }

  if (workspace.status === 'trial' || workspace.status === 'active') {
    return true;
  }

  return workspace.entitlements.features.includes('channels');
};
